import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { getCurrentUser } from '../../services/userService';
import UserSidebar from './UserSidebar';
import AdminSidebar from './AdminSidebar';
import { toast } from 'react-toastify';

interface SidebarProps {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const Sidebar: React.FC<SidebarProps> = ({ isOpen, setIsOpen }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [userData, setUserData] = useState<any>(null);
  const [userLoading, setUserLoading] = useState(true);

  // Fetch user's data including subscription and credit info
  useEffect(() => {
    const fetchUserData = async () => {
      try {
        setUserLoading(true);
        const response = await getCurrentUser();
        if (response.success && response.data) {
          setUserData(response.data);
        }
      } catch (error) {

      } finally {
        setUserLoading(false);
      }
    };
    
    fetchUserData();
  }, []);

  return (
    <nav className={`flex flex-col fixed top-0 w-60 border-l border-slate-200 h-full py-2 z-80 bg-white transition-transform duration-300 md:translate-x-0 ${isOpen ? 'translate-x-0' : 'translate-x-full'}`}>
      {/* Close button for mobile */}
      <button 
        className="md:hidden absolute top-4 left-4 text-slate-500 hover:text-slate-700" 
        onClick={() => setIsOpen(false)}
        aria-label="Close sidebar"
      >
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
          <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
      <div className="navbar-logo mb-2 mx-3">
        <img src="/assets/img/logoRazi.png" alt="Razi Logo" className="h-8 w-auto" />
      </div>

      {userData?.userType === "Admin" ? (
        <>
          {/* Admin Header */}
          <div className="mb-2 mx-3 bg-blue-100 text-blue-800 px-3 py-2 rounded-md">
            <span className="text-sm font-medium">پنل مدیریت</span>
          </div>
          {/* Admin Sidebar Items */}
          <div className="navbar-vertical-content flex flex-col grow overflow-y-auto max-h-[100%] mx-3">
            <AdminSidebar userData={userData} isOpen={isOpen} setIsOpen={setIsOpen} />
          </div>
        </>
      ) : (
        <>
          {/* User Sidebar Items */}
          <div className="mb-2 mx-3">
        <Link 
          to="/new-test-request" 
          className="flex items-center justify-center gap-2 px-3 py-3 bg-indigo-50 hover:bg-indigo-100 rounded-md text-indigo-600 transition-colors"
          onClick={() => toast.warning('شما در حال ثبت درخواست جدید هستید')}
        >
          <svg fill="currentColor" viewBox="0 0 24 24" width="18px" height="18px">
            <path d="M19,11H13V5a1,1,0,0,0-2,0v6H5a1,1,0,0,0,0,2h6v6a1,1,0,0,0,2,0V13h6a1,1,0,0,0,0-2Z"/>
          </svg>
          <span className="text-sm font-medium">درخواست آزمایش جدید</span>
        </Link>
      </div>
      
          <div className="navbar-vertical-content flex flex-col grow overflow-y-auto max-h-[100%] mx-3">
            <UserSidebar userData={userData} />
          </div>
        </>
      )}
      <div className="border-t-1 border-slate-200">
        <div className="mt-2 py-2 px-3 flex justify-center border-1 border-slate-200 rounded-md bg-slate-100 mx-3">
          <div className="py-2 text-sm text-slate-600">
            داشبورد آزمایشگاه رازی
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Sidebar;
